export enum ModuleEnum {
  feedback = 'feedback',
  conversations = 'conversations',
  motivation = 'motivation',
  interviews = 'interviews',
  salesAndServices = 'sales',
}
